
import FormProvider
    from "./FormProvider";
import FormRenderer
    from "./FormRenderer";
import {getOrigin} from "../webform";

const Webform = ({
                     companyID,
                     formID,
                     origin,
                     loading = false,
                     template,
                     submission,
                     ...rest
                 }) => {
    {
        return (
            <>
                <link rel="stylesheet" type='text/css' href={`${origin}/resources/modern/react/dist/webform-basic.css`}/>

                {loading ? (
                    <div className='fz-form-skeleton'>
                        <div className='fz-form-skeleton-item' style={{
                            width: '50%',
                            height: '20px'
                        }}/>
                        <div className='fz-form-skeleton-item' style={{
                            height: '40px',
                            marginBottom: '1rem'
                        }}/>
                        <div className='fz-form-skeleton-item' style={{height: '40px'}}/>
                        <div className='fz-form-skeleton-item' style={{
                            height: '40px',
                            marginBottom: '1rem'
                        }}/>
                        <div className='fz-form-skeleton-item' style={{
                            width: '50%',
                            height: '20px'
                        }}/>
                        <div className='fz-form-skeleton-item' style={{height: '40px'}}/>
                    </div>
                ) : template ? (
                    <FormProvider template={template}
                                  submission={submission ? submission : {}}
                                  isWebform={true}
                                  companyID={companyID}
                                  formID={formID}
                                  origin={getOrigin(origin)}
                                  formRenderer={({
                                                     values,
                                                     template,
                                                     defaultAnswers,
                                                     ...formRendererProps
                                                 }) =>
                                      <>
                                          <FormRenderer values={values} template={template} defaultAnswers={defaultAnswers} {...formRendererProps} {...rest}/>
                                      </>}
                    />
                ) : (
                    <div>Sorry, the form was not able to be loaded.</div>
                )
                }

            </>
        )
    }
}

export default Webform;